import { render, staticRenderFns } from "./Mindbody.vue?vue&type=template&id=641951ed&scoped=true&"
import script from "./Mindbody.vue?vue&type=script&lang=js&"
export * from "./Mindbody.vue?vue&type=script&lang=js&"
import style0 from "./Mindbody.vue?vue&type=style&index=0&id=641951ed&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "641951ed",
  null
  
)

export default component.exports